import React from "react";

const ProfileCard = ({ name, firstName, lastName, email, image }) => {
  const initials = `${firstName?.charAt(0).toUpperCase() || ""}${
    lastName?.charAt(0).toUpperCase() || ""
  }`;

  return (
    <div className="flex items-center p-4 max-w-md border-b bg-white mt-1 pt-3">
      {/* Profile Picture or Initials */}
      {image ? (
        <img
          src={image}
          alt={name}
          className="w-12 h-12 rounded-full mr-4"
        />
      ) : (
        <div className="w-12 h-12 bg-purple-600 text-white rounded-full flex items-center justify-center text-[22px] font-semibold mr-4">
          {initials}
        </div>
      )}

      {/* User Info */}
      <div>
        <h3 className="text-base font-semibold text-gray-800">{name}</h3>
        <a
          href={`mailto:${email}`}
          className="text-sm text-[#010101] hover:underline"
        >
          {email}
        </a>
      </div>
    </div>
  );
};

export default ProfileCard;
